import(/* webpackMode: "eager" */ "/workspace/apps/hen-site/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/apps/hen-site/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/apps/hen-site/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientReady"] */ "/workspace/apps/hen-site/src/component/ClientReady.ts");
